import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'react-bootstrap';
import { messages } from './header.i18n';
import LanguageSelectionDropdown from '../../containers/LanguageSelectionDropdown/LanguageSelectionDropdown';
import Message from '../../containers/Message/Message';

class Header extends React.Component {
  onMessageBarDismissed = () => {
    this.title.focus();
  }

  setTitle = (h1) => {
    this.title = h1;
  };

  renderMessageDisplay() {
    if (this.props.hasMessageDisplay) {
      return <Message onDismissed={this.onMessageBarDismissed} />;
    }
    return null;
  }

  renderTitleDescription() {
    if (this.props.titleDescription) {
      return (
      <div className="understated ar-identifier" tabIndex={0}>
        {this.props.titleDescription}
      </div>);
    }

    return null;
  }

  renderNumberBadge() {
    if (this.props.badgeNumber == null) return null;
    if (this.props.badgeNumber <= 0) return null;

    return (
      <div className="header-new-badge">
        <span className="badge">{this.props.badgeNumber}</span>
        <span className="header-new">
          <FormattedMessage {...messages.labels.newIndicator} />
        </span>
      </div>
    );
  }

  render() {
    const {
      hasLanguageDropdown,
      headerTitle,
      ariaDescribedby,
      headerButtons,
    } = this.props;

    return (
      <>
        {this.renderMessageDisplay()}
        {
          headerTitle ? (
            <Row className={this.props.headerClassName}>
              <Col xs="auto">
                <h1
                  id="content"
                  className="float-start mr-2"
                  data-qa-item="pageHeader"
                  aria-describedby={ariaDescribedby} tabIndex="0"
                  ref={this.setTitle}
                >
                  {headerTitle}
                </h1>

                {this.renderNumberBadge()}
              </Col>
              {
                headerButtons ?
                  <Col>
                    { headerButtons }
                  </Col>
                  :
                  null
              }
              {
                hasLanguageDropdown !== undefined
                && hasLanguageDropdown !== null
                && hasLanguageDropdown === true ?
                  <Col>
                    <LanguageSelectionDropdown />
                  </Col> :
                  null
              }
            </Row>
          ) : (
            <span id="content"></span>
          )
        }
        {this.renderTitleDescription()}
      </>
    );
  }
}

Header.propTypes = {
  headerTitle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  headerClassName: PropTypes.string,
  badgeNumber: PropTypes.number,
  ariaDescribedby: PropTypes.string,
  hasMessageDisplay: PropTypes.bool,
  hasLanguageDropdown: PropTypes.bool,
  titleDescription: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  headerButtons: PropTypes.object,
};

export default Header;
